import { Apis } from "../../config";
import apiService from "../ApiService";

export const getFaqListData = async (data) => {
        const result = await apiService.get(Apis.GetFaqListData(data));
        if (result?.error) {
            return null;
        }
        return result;  
}

export const getFaqDataBySlug = async (data) => {
        const result = await apiService.get(Apis.GetFaqDataBySlug(data));
        if (result?.error) {
            return null;
        }
        return result;
}

export const getCategoryData = async (data) => {
        const result = await apiService.get(Apis.GetCategoryData(data));
        if (result?.error) {
            return null;
        }
        return result;  
}

export const getTopCategoryData = async (data) => {
        const result = await apiService.get(Apis.GetTopCategoriesData(data));
        if (result?.error) {
            return null;
        }
        return result;
}

export const getFaqMetaBySlug = async (slug) => {
        const result = await apiService.get(Apis.GetFaqMetaBySlug(slug));
        if (result?.error) {
            return null;
        }
        return result;  
}
